const ENV = process.env;

export default {
  REACT_APP_ENV_NAME: ENV?.REACT_APP_ENV_NAME,
  REACT_APP_BUGSNAG_API_KEY: ENV?.REACT_APP_BUGSNAG_API_KEY,
  REACT_APP_VERSION: ENV?.REACT_APP_VERSION,
  REACT_APP_BASE_API_URL: ENV?.REACT_APP_BASE_API_URL,
  REACT_APP_USERNAME_FOR_BASIC_AUTH: ENV?.REACT_APP_USERNAME_FOR_BASIC_AUTH,
  REACT_APP_PASSWORD_FOR_BASIC_AUTH: ENV?.REACT_APP_PASSWORD_FOR_BASIC_AUTH,
  REACT_APP_BEARER_TOKEN: ENV?.REACT_APP_BEARER_TOKEN,
  REACT_APP_REPORT_BASE_API_URL: ENV?.REACT_APP_REPORT_BASE_API_URL,
};
